import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Seo } from "@/components/Seo";
import { useLang, setLang as persistLang } from "@/i18n";
import { PRIVACY_CONTENT } from "@/content/privacyContent";
import { LEGAL_LANGS, BACK_LABEL, LegalSections } from "@/utils/legalRenderer";

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  const { lang: appLang } = useLang();
  const lang = PRIVACY_CONTENT[appLang] ? appLang : "it";
  const doc = PRIVACY_CONTENT[lang];

  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <Seo
        title={`${doc.title} · ADE`}
        description="ADE Privacy Policy"
        canonical={`${window.location.origin}/privacy`}
      />
      <div className="max-w-2xl mx-auto px-5 py-8">
        <div className="flex items-center justify-between mb-6">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-gray-500 hover:text-gray-900"
            data-testid="privacy-back"
          >
            <ArrowLeft className="w-5 h-5" /> {BACK_LABEL[lang]}
          </button>
          <div className="flex gap-1" data-testid="privacy-lang-switcher">
            {LEGAL_LANGS.map((l) => (
              <button
                key={l.code}
                onClick={() => persistLang(l.code)}
                data-testid={`privacy-lang-${l.code}`}
                className={`px-2.5 py-1 rounded-lg text-xs font-semibold transition-colors ${
                  lang === l.code
                    ? "bg-gray-900 text-white"
                    : "bg-gray-100 text-gray-500 hover:bg-gray-200"
                }`}
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-testid="privacy-title">
          {doc.title}
        </h1>
        <p className="text-sm text-gray-400 mb-8">{doc.version}</p>

        <LegalSections sections={doc.sections} />

        <p className="text-xs text-gray-400 mt-8 pt-4 border-t">{doc.footer}</p>
      </div>
    </div>
  );
}
